module.exports = "/images/social_background.png?18b1a2f9f21b8d32ddaa530c70eb244d";